import { type ButtonHTMLAttributes, forwardRef, Ref } from 'react';
import { twJoin, twMerge } from 'tailwind-merge';

import { Spinner } from '../Spinner';

export type Props = ButtonHTMLAttributes<HTMLButtonElement> & {
  onClick?: () => void;
  isDisabled?: boolean;
  isLoading?: boolean;
  text?: string;
  ref?: Ref<HTMLButtonElement>;
};

export const BaseButton = forwardRef<HTMLButtonElement, Props>(
  ({ onClick, isDisabled, isLoading, className, text, children, type, ...rest }, ref) => {
    return (
      <button
        {...rest}
        ref={ref}
        type={type ?? 'button'}
        onClick={onClick}
        disabled={isDisabled || isLoading}
        className={twMerge(
          'relative min-w-[60px] flex flex-row items-center justify-center px-4',
          isDisabled && 'cursor-not-allowed',
          className,
        )}
      >
        <div className={twJoin(isLoading && 'opacity-0')}>
          {children ? children : null}
          {text ? <p>{text}</p> : null}
        </div>
        {isLoading ? (
          <div className="absolute top-0 bottom-0 left-0 right-0 flex items-center justify-center">
            <Spinner />
          </div>
        ) : null}
      </button>
    );
  },
);

BaseButton.displayName = 'BaseButton';
